import { pipe, Option } from 'effect';
import type { QueryReduxMirror } from '@/services/query';
import { currentCompanyIdSelector } from '@/domain/router/routerLeafSelectors';
import { companyKeys } from '@/domain/companies/queries/keys';
import { companyCapabilitiesAdapter } from '@/domain/companies/helpers';
import { companyCapabilitiesMirroredAction } from '@/domain/companies/companiesActions';

export const companyCapabilitiesMirror: QueryReduxMirror = {
  mirroredQueryKey: (state) =>
    pipe(Option.fromNullable(currentCompanyIdSelector(state)), Option.map(companyKeys.capabilities), Option.getOrNull),
  actionType: companyCapabilitiesMirroredAction.type,
  toPayload: companyCapabilitiesAdapter,
};
